import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ProcessDefinitionService } from './services/process-definition-service';

export function provideEngineProcesses(): EnvironmentProviders {
  return makeEnvironmentProviders([ProcessDefinitionService]);
}
